import React from 'react';
import { Trans } from '@lingui/react/macro';

import { Box, Button, Display, Flex, Image, Paragraph } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import { SectionProps } from '@rover/kibble/patterns/Section/Section.common';
import useTheme from '@rover/kibble/themes/useTheme';
import { NotReadyToBookSignUpClick } from '@rover/react-lib/src/pages/landing/utilities/analyticsEvents';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import internalLinkingSignUpBanner from './InternalLinkingSignUpBanner.png';

const NotReadyToBook = (props: SectionProps): JSX.Element => {
  const { colors } = useTheme();

  return (
    <Section
      backgroundColor={colors.green['100']}
      pt={['10x', '12x']}
      pb={['10x', '8x']}
      pl={['6x', '0x']}
      pr={['6x', '0x']}
      {...props}
    >
      <Flex flexDirection={['column-reverse', 'row']} alignItems={['stretch', 'center']}>
        <Flex flex="1" flexDirection="column" gap="2x" alignItems={['center', 'flex-start']}>
          <Display size="400" m="0x" textAlign={['center', 'left']}>
            <Trans>Not ready to book?</Trans>
          </Display>
          <Paragraph size="300" textAlign={['center', 'left']} webProps={{ maxWidth: 'none' }}>
            <Trans>
              Get started building your pet's profile and discover trusted pet care in your
              neighborhood.
            </Trans>
          </Paragraph>
          <Box>
            <Button
              variant="primary"
              size="default"
              width="186px"
              maxWidth={['186px']}
              href="/account/continue/?bep=event%3Dnavigation-sign-up"
              onPress={() => emitAnalyticsEvent(new NotReadyToBookSignUpClick({}))}
            >
              <Trans>Sign up</Trans>
            </Button>
          </Box>
        </Flex>
        <Box flex="0 0 250px" display="flex" justifyContent="center">
          <Image
            src={internalLinkingSignUpBanner}
            description="Pet care illustration"
            width="250px"
            height="200px"
            resizeMethod="contain"
          />
        </Box>
      </Flex>
    </Section>
  );
};

export default NotReadyToBook;
